import { render, staticRenderFns } from "./behaviour-section.vue?vue&type=template&id=464c575e"
import script from "./behaviour-section.vue?vue&type=script&lang=js"
export * from "./behaviour-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports